import React from 'react'
import style from './style.module.scss'

export default () =>
  <div className={style.wrap}>
    <div className={style.loader}><div/><div/><div/><div/></div>
  </div>
